<template>
    <div v-if="arg.split(' ').length === 1" class="flex flex-col text-left">
        <span>These shell commands are defined internally.  Type '<span class="italic">help</span>' to see this list.</span>
        <span>Type '<span class="italic">help name</span>' to find out more about the function '<span class="italic">name</span>'.</span>
        <span>Use '<span class="italic">info</span>' to find out more about the shell in general.</span>
        <div class="flex flex-row">
            <div class="flex flex-col">
                <span>echo [arg ...]</span>
                <span>get [filename]</span>
                <span>help [arg]</span>
                <span>info</span>
            </div>
            <div class="flex flex-col ml-3">
                <span>logout</span>
                <span>ls</span>
                <span>quit</span>
            </div>
        </div>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'echo'" class="flex flex-col text-left">
      <span>echo: [arg ...]</span>
      <span>&emsp;Output the arg(s) into the terminal</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'get'" class="flex flex-col text-left">
      <span>get: [filename]</span>
      <span>&emsp;Downloads the coresponding file onto your local machine.  Only downloads files visible within 'ls' and non executable.</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'help'" class="flex flex-col text-left">
      <span>help: [arg]</span>
      <span>&emsp;Display helpful information about builtin commands.  If arg is specified, it will provide infomration on the command provided, otherwise will give a general list of possible commands</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'info'" class="flex flex-col text-left">
      <span>info: </span>
      <span>&emsp;Provide general description of the terminal.</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'logout'" class="flex flex-col text-left">
      <span>logout: </span>
      <span>&emsp;Shut down the current terminal environment.</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'quit'" class="flex flex-col text-left">
      <span>quit: </span>
      <span>&emsp;Shut down the current terminal environment.</span>
    </div>
    <div v-else-if="arg.split(' ')[1] === 'ls'" class="flex flex-col text-left">
      <span>logout: </span>
      <span>&emsp;list the files in your current directory.</span>
    </div>
    <div v-else class="flex flex-col text-left">
      <span>-help: no command '<span>{{ arg.split(' ')[1] }}</span>'</span>
    </div>
</template>

<script>
export default {
  name: 'Help',
  props: {
    arg: {
      type: String,
      required: false
    }
  }
}
</script>
